/* 🤖 this file was generated by svg-to-ts */
export const kzIconsArrowrightFull: {
  name: 'arrowright_full';
  data: string;
} = {
  name: 'arrowright_full',
  data: `<svg version="1.1" id="arrowright-full_svg__Calque_1" x="0" y="0" viewBox="0 0 16 13" xml:space="preserve" enable-background="new 0 0 16 13"><style>.st0{fill:#3c3a39}</style><path fill="currentColor" d="M14.8 7H.8C.3 7 0 6.6 0 6.2s.3-.8.8-.8h14c.4 0 .8.3.8.8s-.4.8-.8.8z"/><path fill="currentColor" d="M9.3 12.4c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1l4.9-4.9-4.9-4.9C8.5 1 8.5.5 8.8.2s.8-.3 1.1 0l5.5 5.5c.3.3.3.8 0 1.1l-5.5 5.5c-.2.1-.4.1-.6.1z"/></svg>`
};
